<template>
    <section class="match-info-section" v-if="event">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <div class="match-info d-flex align-items-start justify-content-center oswald">
                        <div class="team d-flex flex-wrap justify-content-end ">
                            <div>
                                <span class="shield"><img :src="event.equipo_local.imagen"/></span>
                                <div class="title">{{ event.equipo_local.nombre }}</div>
                            </div>
                        </div>
                        <div class="info text-center">
                            <div class="competition">
                                <span>
                                    <img :src="event.division.imagen"/>
                                </span>
                            </div>
                            <div v-if="event.fecha && event.hora">
                                <div class="date">{{ event.fecha }}</div>
                                <div class="time gradient-color">{{ event.hora }}H</div>
                                <small class="d-block w-100" v-if="event.fecha_provisional">Fecha y hora provisional</small>
                            </div>
                        </div>
                        <div class="d-flex team">
                            <div>
                                <span class="shield"><img :src="event.equipo_visitante.imagen"/></span>
                                <div class="title">{{ event.equipo_visitante.nombre }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-lg-center mt-3 pb-4" v-if="event.experiencia == 1">
                    <EventoDescripcion :event="event"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import EventoDescripcion from './EventoDescripcion';

    export default{
        props: {
            event: {
                required: true,
                type: Object
            }
        },
        components: {
            EventoDescripcion
        }
    }
</script>